import { h, hydrate } from 'preact'
import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import { AppContext } from './lib/context.tsx'
import { App } from './components/App.tsx'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

class AppElement extends BaseElement {
  name = tag

  render() {
    hydrate(
      <AppContext.Provider value={{ sendGaEvent: this.sendGaEvent, sendError: this.sendError }}>
        <App {...(this.preloadedState as any)} />
      </AppContext.Provider>,
      this,
    )

    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })
  }

  get preloadedState() {
    return JSON.parse(this.querySelector('script[type="application/json"]').textContent)
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
